import { getRequest } from 'config/Axios/baseConfig';
import {
  ApiResponse,
  ScheduleCalculationsResponse,
} from 'Interfaces/CalculationInterfaces/MainCalculationInterfaces';

export const scheduleCalculationServices = {
  getScheduleCalculations: (
    date?: string,
    includeCompleted: boolean = false
  ): Promise<ScheduleCalculationsResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        // Use today's date if no date is provided
        const targetDate = date || new Date().toISOString().split('T')[0];

        const { data } = await getRequest<ApiResponse<ScheduleCalculationsResponse>>(
          `pps/calculations/get-schedule-calculations/?date=${targetDate}&include_completed=${includeCompleted}`
        );

        resolve(data.data || []);
      } catch (error: any) {
        reject(error);
      }
    });
  }
};
